import React, { Component } from 'react'
import { connect } from 'react-redux';

// custom
import ViewHeader from './view-header';
import ViewContent from './view-content';

// styling
import './style.css';

class AirlineLocation extends Component {
    render() {
        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent/>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    const { authentication } = state;
    const { user } = authentication;
    return user;
}

export default connect(mapStateToProps)(AirlineLocation);


// WEBPACK FOOTER //
// ./src/views/airline-location/index.js